import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoggedUser } from 'src/app/services/authentication/authentication';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { ApiPortfolioSummaryLiteOut, InvestmentListItem } from 'src/app/services/rest-api/rest-api';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';
import { ToastNotificationService } from 'src/app/services/toast-notification/toast-notification.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  templateUrl: './money-deposit-list.component.html',
  styleUrls: ['./money-deposit-list.component.scss'],
  standalone: false
})
export class MoneyDepositListComponent implements OnInit {
  public userInvestments: InvestmentListItem[] = [];

  public preloader = true;

  public disableInvestmentCreation = false;

  public get loggedUser(): LoggedUser {
    if(!this.userService.loggedUser || this.userService.loggedUser === null) {
      this.router.navigate(['/login']);
    }

    return this.userService.loggedUser!;
  }

  public constructor(
    private restApiService: RestApiService,
    public toastService: ToastNotificationService,
    private loggerService: LoggerService,
    private userService: UserService,
    private router: Router,
  ) { }

  public ngOnInit(): void {
    this.restApiService.getSummaryLite().subscribe({
      error: this.handleCalendarError.bind(this),
      next: this.handleCalendarData.bind(this),
    });

    this.disableInvestmentCreation = !(this.loggedUser.validContracts.filter(contract => !contract.inLiquidation).length > 0);
  }

  private handleCalendarData(data: ApiPortfolioSummaryLiteOut[]): void {
    this.userInvestments = data.map(investment => {
      return {
        id: investment.portfolioId,
        name: investment.name,
        type: investment.portfolioType.toLocaleLowerCase() as  'portfolio' | 'strategy',
        dip: investment.dip,
      };
    });
    this.preloader = false;
  }

  private handleCalendarError(error: unknown): void {
    this.preloader = false;
    this.loggerService.error(typeof error === 'function' ? error() : error);

    this.toastService.unknownApiError();
  }
}
